module.exports = __webpack_public_path__ + "static/media/download-pending-w64.2ef0ab06.svg";